"use client";

import CapacityPercentCards from "./CapacityPercentCards";
import CapacityRadarChart from "./CapacityRadarChart";

type CapacityPercentInput = {
    skillListeningSpeaking: number | null;
    skillLangNature: number | null;
    skillReading: number | null;
    skillWriting: number | null;
};

type CapacityOverviewVariant = "narrow" | "wide" | "popup";

type CapacityOverviewProps = {
    capacityPercent: CapacityPercentInput;
    className?: string;
    variant?: CapacityOverviewVariant;
};

const VARIANT_CONFIG: Record<
    CapacityOverviewVariant,
    {
        chartSize: number;
        chartClassName: string;
        chartAreaClassName: string;
        cardsClassName: string;
    }
> = {
    narrow: {
        chartSize: 320,
        chartClassName: "max-w-[min(100%,360px)]",
        chartAreaClassName: "overflow-hidden px-1 py-2",
        cardsClassName: "gap-3",
    },
    wide: {
        chartSize: 380,
        chartClassName: "max-w-[min(100%,440px)]",
        chartAreaClassName: "overflow-hidden px-1 py-2",
        cardsClassName: "gap-4",
    },
    popup: {
        chartSize: 400,
        chartClassName: "w-full max-w-[min(100%,500px)]",
        chartAreaClassName: "overflow-visible px-1 py-0",
        cardsClassName: "gap-4",
    },
};

export default function CapacityOverview({
    capacityPercent,
    className = "",
    variant = "wide",
}: CapacityOverviewProps) {
    const config = VARIANT_CONFIG[variant];

    return (
        <div className={`flex h-full min-h-0 flex-col ${className}`}>
            <div
                className={`flex min-h-0 flex-1 items-center justify-center ${config.chartAreaClassName}`}
            >
                <CapacityRadarChart
                    capacityPercent={capacityPercent}
                    size={config.chartSize}
                    variant={variant}
                    className={config.chartClassName}
                />
            </div>

            <div className="mt-auto shrink-0 pb-1 pt-3">
                <CapacityPercentCards
                    capacityPercent={capacityPercent}
                    className={config.cardsClassName}
                />
            </div>
        </div>
    );
}
